

























import {
  Component,
  Prop,
  Vue,
  Emit,

} from 'vue-property-decorator';
import * as _ from 'lodash';
import axios from "axios";

@Component({})
export default class EditableCell extends Vue {
  private selectKey: any = '1'
  private editable: boolean = false
  @Prop({
    type: String,
    default: ''
  })
  private text: string

  @Prop(
      {
        type: Object,
        default: () => {
          return {}
        }
       }
  )
  private dictData: any


  get computeValue() {
    return this.text
  }
  private created() {
  }
  private handleChange(e: any) {
    const value = e;
    this.selectKey = value;
  }


  private check() {
    let val = this.dictData[this.selectKey]
    this.editable = false;
    this.$emit('change', val);
    this.$emit('flag', this.editable)
  }

  private edit() {
    this.editable = true;
    for (let i in this.dictData) {
      if (this.computeValue === this.dictData[i]) {
        this.selectKey = i
      }
    }
    this.$emit('flag', this.editable)
  }

}
